(() => {
  const STORAGE_KEY = "alphaAgeVerified"; // sessionStorage -> 1x pro Session
  const gate = document.querySelector("[data-age-gate]");
  if (!gate) return;

  const dialog = gate.querySelector("[data-age-gate-dialog]");
  const btnYes = gate.querySelector("[data-age-gate-yes]");
  const btnNo = gate.querySelector("[data-age-gate-no]");

  // Hauptinhalt (für Screenreader "inert" machen)
  // Wir nehmen <main> wenn vorhanden, sonst body children außer gate.
  const main = document.querySelector("main");

  let lastFocused = null;

  const getFocusable = (root) => {
    const selectors = [
      "a[href]",
      "area[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])"
    ];
    return Array.from(root.querySelectorAll(selectors.join(",")))
      .filter(el => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"));
  };

  const setAppInert = (isInert) => {
    const target = main || document.body;

    if (isInert) {
      target.setAttribute("inert", "");
    } else {
      target.removeAttribute("inert");
    }
  };


  const lockScroll = () => {
    document.documentElement.classList.add("alpha-age-gate--locked");
    document.body.classList.add("alpha-age-gate--locked");
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove("alpha-age-gate--locked");
    document.body.classList.remove("alpha-age-gate--locked");
  };

  const openGate = () => {
    if (!dialog || !btnYes || !btnNo) return;

    lastFocused = document.activeElement;

    gate.hidden = false;
    lockScroll();
    setAppInert(true);

    // Fokus in den Dialog setzen
    dialog.focus({ preventScroll: true });

    // Fokusfalle / Keyboard-Handling
    document.addEventListener("keydown", onKeyDown, true);

    // Absichtlich KEIN click-outside close (sonst Umgehung)
    // Absichtlich ESC blocken (sonst Umgehung)
  };

  const closeGate = () => {
    gate.hidden = true;
    unlockScroll();
    setAppInert(false);

    document.removeEventListener("keydown", onKeyDown, true);

    // Fokus zurück
    if (lastFocused && typeof lastFocused.focus === "function") {
      lastFocused.focus({ preventScroll: true });
    }
  };

  const denyAccess = () => {
    // Harte Sperre: Seite bleibt blockiert.
    // Optional: Redirect auf Info-Seite. Hier: wir ersetzen Dialog-Inhalt.
    dialog.innerHTML = `
      <h2 id="alpha-age-gate-title" class="alpha-age-gate__title">Zugriff nicht möglich</h2>
      <p id="alpha-age-gate-desc" class="alpha-age-gate__desc">
        Du musst mindestens 18 Jahre alt sein, um diesen Shop zu besuchen.
      </p>
      <p class="alpha-age-gate__hint">
        Bitte schließe den Browser oder verlasse diese Seite.
      </p>
    `;

    // Fokusfalle bleibt aktiv, damit nix im Hintergrund erreichbar ist
    dialog.focus({ preventScroll: true });
  };

  const verify = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "true");
    } catch (e) {
      // Wenn sessionStorage blockiert ist (sehr selten), dann bleibt es halt bei jeder Seite.
      // Das ist korrekt im Sinne von "sicherer" statt "durchlässiger".
    }
    closeGate();
  };

  const onKeyDown = (e) => {
    // ESC blocken (kein Bypass)
    if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Fokusfalle nur wenn Gate offen
    if (gate.hidden) return;

    if (e.key === "Tab") {
      const focusables = getFocusable(dialog);
      if (focusables.length === 0) {
        e.preventDefault();
        return;
      }
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      // Shift+Tab auf erster -> zum letzten
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
        return;
      }
      // Tab auf letzter -> zum ersten
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
        return;
      }
    }
  };

  // Button Events
  btnYes?.addEventListener("click", verify);
  btnNo?.addEventListener("click", denyAccess);

  // Start: prüfen ob schon verifiziert
  const isVerified = (() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "true";
    } catch (e) {
      return false;
    }
  })();

  if (!isVerified) {
    openGate();
  }
})();
